import { mapGetters, mapState } from "vuex";
// import config from "../nuxt.config";

export const matomoCustom = {
  computed: {
    ...mapState("Profile", ["dataUser", "userSubscription"]),
    ...mapGetters("Profile", ["getCompany"]),
  },
  created() {
    // Should not really be used...
    // if (this.$store.state.Profile.dataUser && this.$matomo && this.$route) {
    //
    //     const url = `${config.env.BASE_URL}${this.$route.fullPath}`
    //     const userFieldCompany = this.getCompany
    //     const userFieldName = this.dataUser.field_name && this.dataUser.field_name.length ? this.dataUser.field_name[0].value : ""
    //     let userSubscriptions = ""
    //     if (this.userSubscription && this.userSubscription.length) {
    //         this.userSubscription.forEach((el) => {
    //             userSubscriptions = userSubscriptions + el.field_product_id + ", "
    //         })
    //         userSubscriptions = userSubscriptions.slice(0, -2)
    //     }
    //     // this.$matomo.trackPageView({
    //     //     customDimensions: [{id: 1, value: userFieldCompany, url}, {
    //     //         id: 2,
    //     //         value: userFieldName,
    //     //         url
    //     //     }, {id: 3, value: userSubscriptions, url}]
    //     // })
    // }
  },
};
